module.exports = __webpack_public_path__ + "static/media/settings-work-tool.eda1f812.svg";